import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useUserContext } from "../contexts/UserContext";
import axiosInstance from "../utils/axiosInstance";
import Trans from '../locales/translations';
import '../styles/loginForm.css';
import { auth, provider, signInWithPopup } from "../firebase";

const LoginForm = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setUser } = useUserContext();
    const navigate = useNavigate(); // Initialize useNavigate

    const handleEmailChange = (e) => setEmail(e.target.value);

    const handlePasswordChange = (e) => setPassword(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axiosInstance.post('/auth/login', {
                email,
                password,
            });

            const { token, user } = response.data;

            console.log('Response Data:', response.data);
            console.log('Token:', token);

            if (token) {
                console.log('WILL STORE TOKEN');
                try {
                    localStorage.setItem('token', token);
                } catch (e) {
                    console.error('Error setting token in localStorage:', e);
                }
                console.log('Stored Token:', localStorage.getItem('token'));
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                setUser(user);
                onLogin(user);
                navigate('/lazywa'); // Redirect to /lazywa after successful login
            } else {
                console.error('No token received from server');
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                setError(error.response.data.error);
            } else {
                setError('Login failed. Please try again later.');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleSignIn = async () => {
        console.log('Google Sign-In process started.');
        setLoading(true);

        try {
            // Start Google sign-in process
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const token = await user.getIdToken();

            // Store the token in localStorage
            try {
                localStorage.setItem('token', token);
            } catch (e) {
                console.error('Error setting token in localStorage:', e);
            }

            // Set the token in axios headers

            // Update user context
            setUser(user);

            // Call backend to check or add user
            try {
                const { data } = await axiosInstance.post('/auth/check-or-add-user', {
                    userId: user.uid,
                    email: user.email
                });

                // Check if the user was successfully added or found
                if (data.success) {
                    onLogin(data.user); // Handle successful login (or update user context)
                    navigate('/lazywa'); // Redirect to /lazywa after successful login
                } else {
                    console.error('User check/add failed:', data.message);
                    setError('Failed to verify user. Please try again later.');
                }
            } catch (dbError) {
                console.error('Error calling check-or-add-user API:', dbError.message);
                setError('An error occurred while checking or adding user. Please try again later.');
            }
        } catch (error) {
            console.error("Google sign-in popup error:", error.message);
            setError('Google sign-in failed. Please try again later.');
        } finally {
            console.log('Google Sign-In process finished.');
            setLoading(false);
        }
    };

    return (
        <div>
            <Form onSubmit={handleSubmit} className="custom-form d-flex justify-content-center">
                {/*<Form.Group controlId="formEmail" className="mb-3">*/}
                {/*    <Form.Label><Trans k="login-form.email" /></Form.Label>*/}
                {/*    <Form.Control*/}
                {/*        type="email"*/}
                {/*        value={email}*/}
                {/*        onChange={handleEmailChange}*/}
                {/*        className="form-control-lg rounded-pill"*/}
                {/*        required*/}
                {/*    />*/}
                {/*</Form.Group>*/}
                {/*<Form.Group controlId="formPassword" className="mb-3">*/}
                {/*    <Form.Label><Trans k="login-form.password" /></Form.Label>*/}
                {/*    <Form.Control*/}
                {/*        type="password"*/}
                {/*        value={password}*/}
                {/*        onChange={handlePasswordChange}*/}
                {/*        className="form-control-lg rounded-pill"*/}
                {/*        required*/}
                {/*    />*/}
                {/*</Form.Group>*/}
                {error && (
                    <Alert variant="danger" className="rounded-pill">
                        {error !== 'Login failed. Please try again later.' ? error : <Trans k="login-form.default-error" />}
                    </Alert>
                )}
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : (
                    <>
                        <Button
                            variant="outline-light"
                            onClick={handleGoogleSignIn}
                            className="btn-google btn-lg rounded-pill mt-3"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                    <span className="ms-2">Signing in...</span>
                                </>
                            ) : (
                                <>
                                    <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google Logo" className="google-logo me-2" />
                                    Sign in with Google
                                </>
                            )}
                        </Button>
                    </>
                )}
            </Form>
        </div>
    );
};

export default LoginForm;
